export const labelWidth = '9rem';
export const inputWidth = '5.5rem';
